import type { TSerializedWidget } from 'src/entities/workspace/types';
import { FiltersWidgetEntity } from 'src/pages/dashboard/features/filters-widget/FiltersWidget.entity';
import { parseFiltersWidgetInternalState } from 'src/pages/dashboard/features/filters-widget/parseFiltersWidget';
import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

export function mapFiltersWidget(widget: TSerializedWidget, index: number): FiltersWidgetEntity {
  const internalState = parseFiltersWidgetInternalState(widget.internalState);

  return new FiltersWidgetEntity(
    {
      type: 'filters-widget',
      stateParams: internalState.stateParams,
    },
    {
      uuid: widget.uuid,
      groupId: widget.groupId,
      isPinned: !!widget.isPinned,
      isFullscreen: widget.isFullscreen,
      size: widget.size,
      position: widget.position,
      zIndex: 100 + index,
      isGroupsDefaultOpened: false,
    },
  );
}

/** Migrates saved `filter-control` widgets/templates to the new FiltersWidget. */
export function mapLegacyWellsFilterToFiltersWidget(
  widget: TSerializedWidget | TSerializedWidgetTemplate,
  index: number,
): FiltersWidgetEntity {
  return new FiltersWidgetEntity(
    {
      type: 'filters-widget',
      stateParams: {},
    },
    {
      uuid: widget.uuid,
      groupId: widget.groupId,
      isPinned: 'isPinned' in widget ? !!widget.isPinned : false,
      isFullscreen: 'isFullscreen' in widget ? !!widget.isFullscreen : false,
      size: widget.size,
      position: widget.position,
      zIndex: 100 + index,
      isGroupsDefaultOpened: false,
    },
  );
}
